export { newId, isUlid, isUuid, isEntityId } from "./id.js";
export { SCANNER_CATALOG, REGISTERED_SCANNER_ADAPTERS, } from "./scanner-catalog.js";
export { EMPLOYMENT_TYPES, CLAIM_CONFIDENCE, WORK_AUTH_STATUSES, SKILL_CATEGORIES, slugifyLensId, } from "./candidate-graph.js";
// Canonical application states
export const CANONICAL_STATES = [
    "Evaluated", "Applied", "Responded", "Interview",
    "Offer", "Rejected", "Discarded", "SKIP",
];
// Prompt kinds
export const PROMPT_KINDS = [
    "evaluate", "research", "pdf", "fix-portal", "assistant",
    "apply-prefill", "cv-ingest", "cig-parse", "ai-hunt", "ai-hunt-v2",
    "apply-form-interpret", "apply-drive",
    "oferta", "scan", "cover", "interview-prep",
    "apply", "interview-plan", "interview-practice",
    "interview-debrief", "contacto", "deep", "patterns",
    "followup", "batch", "training", "project", "latex",
    "email", "_shared", "_profile",
    "job-parse", "company-research", "job-research", "job-research-light", "job-research-deep", "offer-review",
];
// ----  S3 Document assets / send ledger  --------------------------------------------
export const DOCUMENT_DOC_TYPES = [
    "cv",
    "cover_letter",
    "portfolio",
    "company_research",
    "other",
];
export const DOCUMENT_SEND_CHANNELS = [
    "apply",
    "email",
    "portal",
    "other",
];
// ----  Career Goals / Plans / Activities / Moves  ------------------------------------
export const CAREER_GOAL_TYPES = [
    "role",
    "skill",
    "network",
    "offer",
    "custom",
];
export const CAREER_GOAL_STATUSES = [
    "active",
    "paused",
    "completed",
    "abandoned",
];
export const CAREER_CONFIDENCE_LEVELS = ["low", "medium", "high"];
export const EFFORT_WEIGHTS = ["S", "M", "L"];
export const CAREER_PLAN_KINDS = [
    "search",
    "networking",
    "negotiation",
    "direction",
    "onboarding",
];
export const CAREER_PLAN_STATUSES = [
    "active",
    "paused",
    "completed",
    "abandoned",
];
export const ACTIVITY_STATES = [
    "planned",
    "due",
    "done",
    "skipped",
    "cancelled",
];
export const CAREER_MOVE_BUCKETS = [
    "ACT_NOW",
    "REPLY_NEEDED",
    "READY_TO_ADVANCE",
    "AT_RISK",
    "WAITING",
    "NURTURE",
];
export const CAREER_MOVE_LIFECYCLE_STATUSES = [
    "ACTIVE",
    "SNOOZED",
    "DELEGATED",
    "COMPLETED",
    "DISMISSED",
    "SUPERSEDED",
];
export const CAREER_MOVE_PRIORITIES = [
    "critical",
    "high",
    "normal",
    "low",
];
export const CAREER_MOVE_ACTION_KINDS = [
    "EXECUTE_PRIMARY",
    "LATER",
    "NOT_RIGHT",
    "DISMISS",
    "DELEGATE",
    "UNDO",
    "COMPLETE",
];
/** Merged view of global Company + user UserCompany shell. */
/** Sensible starter boards when a user has not configured jobBoards yet. */
export const DEFAULT_JOB_BOARDS = [
    "remoteok",
    "hackernews",
];
//# sourceMappingURL=index.js.map